import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import styled, { keyframes } from "styled-components";

type FadeInProps = {
  children: ReactNode;
} & ComponentPropsWithoutRef<"div">;

const FadeIn = ({ children, ...props }: FadeInProps) => (
  <FadeInContainer {...props}>{children}</FadeInContainer>
);

export default FadeIn;

const fadein = keyframes`
     0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const FadeInContainer = styled.div`
    animation: ${fadein} ease 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
`;
